import React from 'react';
import { NavigationActions, DrawerActions } from '@react-navigation/native';
import { Device } from 'DeviceUtils';
import { hide } from 'ReduxStore/drawer';
import { store } from 'ReduxStore/store';

let topLevelNavigation;
let appNavigation;
let activeMenuItem = 'home'; // 'watch-tv';
let previousMenuItem = '';
let menuComponent = null;
let subMenuComponent = () => {};
let isMenuVisible = true;
let currentRoute = '';

const handleScroll = ({ nativeEvent /* , hide, show  */ }) => {
    if (menuComponent) {
        const { contentOffset } = nativeEvent;
        const { y } = contentOffset;
        if (isMenuVisible && y > 80) {
            isMenuVisible = false;
        } else if (!isMenuVisible && y < 80) {
            isMenuVisible = true;
        }
    }
};
const getPath = ([current, ...rest]) => {
    if (!current) return '';
    const route = current.routeName.toLowerCase();
    if (rest.length === 0) return route;
    return `${route}/${getPath(rest)}`;
};

class NavigationService {
    static DEFAULT_SCROLL_THROTTLE = 300;

    static globalParams = {
        myRecordingsLabel: null,
        plannedRecordingsLabel: null,
        iptvRecordingsLabel: null
    };

    static setTopLevelNavigationInstance = (navigation) => {
        topLevelNavigation = navigation;
    };

    static getTopLevelNavigationInstance = () => topLevelNavigation;

    static setAppNavigationInstance = (navigation) => {
        appNavigation = navigation;
    };

    static getAppNavigationInstance = () => appNavigation;

    static openDrawer = () => {
        NavigationService.getTopLevelNavigationInstance().dispatch(DrawerActions.openDrawer());
    };

    static closeAppDrawerAndNavigate = (targetPath) =>
        new Promise((resolve) => {
            const navigation = NavigationService.getAppNavigationInstance();
            if (!Device.isWeb) store.dispatch(hide());
            setTimeout(() => {
                navigation.navigate(targetPath);
                resolve();
            }, 0);
        });

    static getActiveMenuItem = () => activeMenuItem;

    static setActiveMenuItem = (menuItem) => {
        previousMenuItem = String(activeMenuItem);
        activeMenuItem = menuItem;

        return activeMenuItem;
    };

    static getPreviousMenuItem = () => previousMenuItem;

    static setMenuComponent = (component) => {
        menuComponent = component;
    };

    static setSubMenuComponent = (component) => {
        subMenuComponent = component;
    };

    // static getTopBarHandler = (a) => handleScroll;

    static getCurrentRoute = () => currentRoute;

    static setActiveRoute = (routes, activeRoute) => {
        if (routes.find((route) => route.key === activeRoute)) {
            NavigationService.setActiveMenuItem(activeRoute);
        }
    };

    static navigationChangeHandler = (logEvent) => (prevState, nextState, action) => {
        if (action.type === DrawerActions.OPEN_DRAWER) {
            logEvent({ type: 'navigation', subtype: 'menuOpen' });
        }
        if (action.type === DrawerActions.CLOSE_DRAWER) {
            logEvent({ type: 'navigation', subtype: 'menuClose' });
        }
        if (action.type === NavigationActions.NAVIGATE) {
            currentRoute = action.routeName;
            const [rootStack] = nextState.routes;
            if (rootStack.routes) {
                const { routes } = rootStack.routes[rootStack.index];
                const pageId =
                    action.routeName || action.params.title || action.params.item.getId() || '';
                logEvent({
                    type: 'navigation',
                    subtype: 'page',
                    content1: pageId,
                    content2: getPath(routes || [])
                });
                NavigationService.setActiveRoute(rootStack.routes, pageId);
            }
        }
    };
}

export default NavigationService;
